var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5C7 3.34315 8.34315 2 10 2H14C15.6569 2 17 3.34315 17 5V10H18C19.6569 10 21 11.3431 21 13V17C21 18.6569 19.6569 20 18 20H6C4.34315 20 3 18.6569 3 17V13C3 11.3431 4.34315 10 6 10H7V5ZM9 10H15V5C15 4.44772 14.5523 4 14 4H13V5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5V4H10C9.44772 4 9 4.44772 9 5V10ZM7 12H6C5.44772 12 5 12.4477 5 13V17C5 17.5523 5.44772 18 6 18H11V12H9V13C9 13.5523 8.55228 14 8 14C7.44772 14 7 13.5523 7 13V12ZM13 12V18H18C18.5523 18 19 17.5523 19 17V13C19 12.4477 18.5523 12 18 12H17V13C17 13.5523 16.5523 14 16 14C15.4477 14 15 13.5523 15 13V12H13Z",
    fill: "#293042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.56b65902ca234925323df6c4921d6631.svg";
export { ForwardRef as ReactComponent };